import React, { useEffect, useState } from "react";
import { LOCALSTORAGE } from '../../Config';
import { useNavigate } from "react-router-dom";
import { useTheme } from '../../Components/theme/ThemeContext.jsx';
import SeasonalCardToggle from '../../Components/theme/SeasonalCardToggle.jsx';
import GameStatsButton from '../GameStatsButton.jsx';


const normalizeTeamName = (name) => {
  return (name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
};

const mlbTeamLogo = (team) =>
  team?.id ? `https://www.mlbstatic.com/team-logos/${team.id}.svg` : null;

const matchGamesWithLogos = (mlbGames, espnGames) => {
  return mlbGames.map((mlbGame) => {
    const homeTeamName = normalizeTeamName(mlbGame.teams.home.team.name);
    const awayTeamName = normalizeTeamName(mlbGame.teams.away.team.name);

    const matchedEspnGame = espnGames.find((espnGame) => {
      const espnHomeTeam = espnGame.competitions[0].competitors.find(
        (team) => team.homeAway === "home"
      ).team.displayName;
      const espnAwayTeam = espnGame.competitions[0].competitors.find(
        (team) => team.homeAway === "away"
      ).team.displayName;

      return (
        normalizeTeamName(espnHomeTeam) === homeTeamName &&
        normalizeTeamName(espnAwayTeam) === awayTeamName
      );
    });

    if (matchedEspnGame) {
      const espnHomeTeam = matchedEspnGame.competitions[0].competitors.find(
        (team) => team.homeAway === "home"
      );
      const espnAwayTeam = matchedEspnGame.competitions[0].competitors.find(
        (team) => team.homeAway === "away"
      );

      return {
        ...mlbGame,
        gameTitle: matchedEspnGame.shortName,
        homeLogo: espnHomeTeam?.team?.logo || mlbTeamLogo(mlbGame.teams.home.team),
        awayLogo: espnAwayTeam?.team?.logo || mlbTeamLogo(mlbGame.teams.away.team),
        inning: matchedEspnGame.competitions[0].status.type.detail,
      };
    }

    return {
      ...mlbGame,
      gameTitle: `${mlbGame.teams.away.team.name} vs ${mlbGame.teams.home.team.name}`,
      homeLogo: mlbTeamLogo(mlbGame.teams.home.team),
      awayLogo: mlbTeamLogo(mlbGame.teams.away.team),
      inning: mlbGame.status.detailedState, // Fallback to MLB's game state
    };
  });
};

const MlbTodaysGames = () => {
  const [todaysGameArr, setTodaysGameArr] = useState([]);
  const navigate = useNavigate();

  const actionBtnOne = (game) => {
    const gameDetails = {
      game_ID: game.gamePk,
      gameTitle: game.gameTitle,
      gameTime: game.gameDate,
      gameDay: new Date(game.gameDate).toLocaleDateString("en-US", {
        weekday: "short",
      }),
      homeLogo: game.homeLogo,
      awayLogo: game.awayLogo,
      homeTeam: game.teams.home.team.name,
      awayTeam: game.teams.away.team.name,
      sportType: "MLB",
    };
    localStorage.setItem(
      LOCALSTORAGE.SELECTEDGAME,
      JSON.stringify(gameDetails)
    );
    navigate("/betPage");
  };

  const todaysSchedule = async () => {
    // Get the current date in the correct format
    const today = new Date();
    const currentDate = today.toISOString().split("T")[0];

    // Fetch data from ESPN API
    const espnResponse = await fetch(
      "https://site.api.espn.com/apis/site/v2/sports/baseball/mlb/scoreboard"
    );
    const espnData = await espnResponse.json();

    // Fetch data from MLB Stats API
    const mlbApiResponse = await fetch(
      `https://statsapi.mlb.com/api/v1/schedule/games/?sportId=1&date=${currentDate}`
    );
    const mlbApiData = await mlbApiResponse.json();

    // Match games and merge logos
    const matchedGames = matchGamesWithLogos(
      mlbApiData.dates[0]?.games || [],
      espnData.events || []
    );

    setTodaysGameArr(matchedGames);
  };

  useEffect(() => {
    todaysSchedule();
  }, []);
  return (
   <>
      <h1>Todays Games</h1>
      <div className="row justify-content-center">
        {todaysGameArr.length > 0 ? (
          todaysGameArr.map((game) => {
            const isFinal = game.status?.abstractGameState === "Final";

            return (
            <div
              key={game.gamePk}
              className="col-3 card m-1 seasonal-sport-card position-relative"
              style={{ width: "20rem", opacity: isFinal ? 0.5 : 1 }}
            >
              <span className="seasonal-sport-card__spider" aria-hidden="true">🕷️</span>
              <span className="seasonal-sport-card__lights" aria-hidden="true">
                {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
              </span>
              <div className="card-body">
                <GameStatsButton gameId={game.gamePk} sport="MLB" title={game.gameTitle} />
                <h5 className="card-title">{game.gameTitle}</h5>
                <div className="row">
                  <div className="col">
                    {game.awayLogo ? (
                      <img
                        src={game.awayLogo}
                        alt="Away Team Logo"
                        className="img-fluid"
                      />
                    ) : (
                      <p>{game.teams.away.team.name}</p>
                    )}
                  </div>
                  <div className="col">
                    {game.homeLogo ? (
                      <img
                        src={game.homeLogo}
                        alt="Home Team Logo"
                        className="img-fluid"
                      />
                    ) : (
                      <p>{game.teams.home.team.name}</p>
                    )}
                  </div>
                </div>
                <p>
                  {new Date(game.gameDate).toLocaleString("en-US", {
                    weekday: "long",
                    hour: "numeric",
                    minute: "numeric",
                  })}
                </p>
                <p>{game.inning}</p>
                <button
                  onClick={() => actionBtnOne(game)}
                  className="btn btn-outline-primary w-75"
                  disabled={isFinal}
                  title={isFinal ? "This game has ended" : undefined}
                >
                  {isFinal ? "Game Over" : "Bet Friends"}
                </button>
              </div>
            </div>
            );
          })
        ) : (
          <p>No live games currently.</p>
        )}
      </div>
</>
  );
};

const MlbSchedule = () => {
  const { theme, seasonalCardsEnabled } = useTheme();

const backgroundColor =     theme === "retro"
      ? {
          background: "linear-gradient(to bottom, #0B1305 0%, #00008B 100%)",
          color: "#FFFFFF",
          minHeight: "100vh",
          width: "100%", // Ensure full width
        }
      : {
          backgroundColor: theme === "light" ? "#e0e0e0" : "#333333",
          color: theme === "light" ? "#000000" : "#FFFFFF",
          minHeight: "100vh",
          width: "100%",
        };
  console.log("MlbSchedule rendered with theme:", theme);
  return (
    <div
      style={backgroundColor}
      className={`container text-center p-2 seasonal-card-toggle-anchor ${seasonalCardsEnabled ? "seasonal-card-theme-enabled" : ""}`}
    >
      <SeasonalCardToggle />
      <MlbTodaysGames/>
    </div>
  );
};
export { MlbTodaysGames, MlbSchedule };
